var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-lg-4 col-md-6 col-12" },
    [
      _c("router-link", { attrs: { to: _vm.link } }, [
        _c("div", { staticClass: "card card--activity" }, [
          _c("div", { staticClass: "card__deal-type" }, [
            _c("h4", [_vm._v(_vm._s(_vm.activityType))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid justify-space-between align-center" },
            [
              _c("div", { staticClass: "col-lg-4 col-12" }, [
                _c("picture", { staticClass: "card__thumbnail" }, [
                  _c("img", {
                    staticClass: "card__image",
                    attrs: { src: _vm.backgroundUrl, alt: "Activity Image" },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-8 col-12" }, [
                _c("h3", { staticClass: "card__title" }, [
                  _vm._v(_vm._s(_vm.activityName)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "card__activity_type" }, [
                  _vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end)),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }